import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as PropTypes from 'prop-types'

import {
  selectGroupFilter,
  setGroupForFilter,
} from '../../../../reducers/Organisation/groupsReducer'
import { toolbarTabOptions, allGroupsOption } from '../../helpers'
import Filter from '../../../../components/Filter/Filter'
import API from '../../../../api/api'

const GroupPostsToolbar = ({ selectedTab, setSelectedTab, buildingId }) => {
  const dispatch = useDispatch()
  const selectedGroupFilter = useSelector(selectGroupFilter)
  const [groupsOptions, setGroupsOptions] = useState([])
  const getFreshGroups = async (buildingId) => {
    const { data: freshGroups } = await API.getGroups(buildingId)
    if (freshGroups.length) {
      setGroupsOptions([
        allGroupsOption,
        ...freshGroups.map((group) => ({
          id: group.id,
          text: group.name,
          value: group.id,
        })),
      ])
    }
  }

  useEffect(() => {
    if (buildingId) {
      getFreshGroups(buildingId).catch(() => {})
      dispatch(setGroupForFilter(allGroupsOption))
    }
  }, [buildingId, dispatch])

  return (
    <div className="group-posts-toolbar">
      <div className="group-posts-toolbar__filters">
        <Filter
          placeholder={selectedTab.text}
          options={toolbarTabOptions}
          value={selectedTab ? [selectedTab] : []}
          name="typeFilter"
          variant="borderless"
          onChange={(e) => setSelectedTab(e.target.value)}
          closeAfterSelect
        />
        <Filter
          placeholder={selectedGroupFilter ? selectedGroupFilter.text : allGroupsOption.text}
          options={groupsOptions}
          value={selectedGroupFilter ? [selectedGroupFilter] : []}
          name="GroupFilter"
          variant="borderless"
          onChange={(e) => dispatch(setGroupForFilter(e.target.value))}
          closeAfterSelect
        />
      </div>
    </div>
  )
}

GroupPostsToolbar.propTypes = {
  selectedTab: PropTypes.object,
  buildingId: PropTypes.number,
  selectedGroupFilter: PropTypes.object,
  setSelectedTab: PropTypes.func,
  setGroupForFilter: PropTypes.func,
}

export default GroupPostsToolbar
